import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const LinkedIn: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58">
            <g id="LinkedIn" transform="translate(-9732.309 -6042.478)">
                <g
                    id="Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                    data-name="Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                    transform="translate(9732.309 6042.478)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                >
                    <rect width="59" height="58" rx="29" stroke="none" />
                    <rect x="1" y="1" width="57" height="56" rx="28" fill="none" />
                </g>
                <g
                    id="Icon_ICON_feather_instagram_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_"
                    data-name="Icon [ICON=feather/instagram][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]"
                    transform="translate(9749.102 6059.195)"
                >
                    <rect
                        id="Area_ICON:feather_instagram_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                        data-name="Area [ICON:feather/instagram][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                        width="24"
                        height="24"
                        transform="translate(0.207 0.282)"
                        fill="rgba(253,73,198,0.35)"
                        opacity="0"
                    />
                    <g id="Icon" transform="translate(0 0.614)">
                        <path
                            id="f9230ae9-944c-4f1c-943f-24b460c3cba2"
                            d="M17.369,8a7.369,7.369,0,0,1,7.369,7.369v8.6H19.826v-8.6a2.456,2.456,0,0,0-4.913,0v8.6H10v-8.6A7.369,7.369,0,0,1,17.369,8Z"
                            transform="translate(-0.174 -0.631)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                        <rect
                            id="_9a7aea1d-c792-4bce-b30c-f621d8b2ddc1"
                            data-name="9a7aea1d-c792-4bce-b30c-f621d8b2ddc1"
                            width="4.913"
                            height="14.739"
                            transform="translate(0 8.598)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                        <circle
                            id="_6ffdc87f-90a7-4586-b35b-73a324d1c5c0"
                            data-name="6ffdc87f-90a7-4586-b35b-73a324d1c5c0"
                            cx="2.456"
                            cy="2.456"
                            r="2.456"
                            transform="translate(0 0)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(LinkedIn);
